import React from "react";
import { toast } from "sonner";

/**
 * ConsoleStagePanel — Stage Layout button row + helper hint, lifted out
 * of `DirectorConsole.jsx` to keep that page closer to its reasonable
 * line budget.
 *
 * The Stage Layout chips here mirror the same grid on
 * `AdvancedDirectorPanel`; the two stay in sync via the
 * `tapin:stage-layout` CustomEvent + the `tapin_stage_layout`
 * localStorage key. Either click site triggers both, so flipping a
 * layout in this rail flips the embedded panel and vice versa.
 */
const LAYOUTS = [
  { k: "solo", lbl: "Solo", multi: false },
  { k: "split", lbl: "Split", multi: true },
  { k: "pip", lbl: "PIP", multi: true },
  { k: "grid", lbl: "Grid", multi: true },
];

export default function ConsoleStagePanel() {
  const onPick = (l) => {
    try { localStorage.setItem("tapin_stage_layout", l.k); } catch { /* quota */ }
    try { window.dispatchEvent(new CustomEvent("tapin:stage-layout", { detail: l.k })); } catch { /* no-op */ }
    if (l.multi) {
      toast.success(`Stage: ${l.lbl} — assign guest cams below`, { id: "stage-switch" });
      const gm = document.getElementById("director-guests");
      if (gm) gm.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      toast.success(`Stage: ${l.lbl}`, { id: "stage-switch" });
    }
  };

  return (
    <>
      <div className="text-[9px] uppercase tracking-wider font-black text-white/50 mt-1">Stage Layout</div>
      <div className="grid grid-cols-2 gap-1.5">
        {LAYOUTS.map((l) => (
          <button
            key={l.k}
            data-testid={`stage-${l.k}`}
            onClick={() => onPick(l)}
            className="bg-white/5 hover:bg-white/10 text-white text-[10px] font-bold py-1.5 rounded border border-white/10"
          >
            {l.lbl}
          </button>
        ))}
      </div>
      <a
        href="#director-guests"
        data-testid="console-stage-guest-hint"
        className="block text-[10px] text-white/55 hover:text-white transition border border-dashed border-white/10 hover:border-white/25 rounded px-2 py-1.5 leading-snug"
      >
        Multi-cam + PIP use guests on CAM 1 / 2 / 3 — manage slots in the Guests panel →
      </a>
    </>
  );
}
